import { IOption } from "../../../../../features/forms/fields/select-field/select-field.props";

export const NumberOfStoresOptions: IOption[] = [
  { value: "Top 50", label: "Top 50" },
  { value: "Top 100", label: "Top 100" },
  { value: "Top 150", label: "Top 150" },
  { value: "Top 200", label: "Top 200" },
  { value: "Top 300", label: "Top 300" },
  { value: "Select locations", label: "Select locations" },
  { value: "Apple stores only", label: "Apple stores only" },
  { value: "All stores", label: "All stores" },
  { value: "All English stores", label: "All English stores" },
  { value: "Other", label: "Other" },
];
